// extracted by mini-css-extract-plugin
export default {"hero":"Hero-module_hero__VsNIa","contain":"Hero-module_contain__gE9jd","imageCol":"Hero-module_imageCol__zOz49","descriptionCol":"Hero-module_descriptionCol__zo3sg"};